module.exports = __webpack_public_path__ + "img/ss_green-10.4dcad7e4.jpg";